import { Button } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SaveButton } from '@/shared/ui';

type Props = {
  isDirty: boolean;
  isSaving: boolean;
  /** Новая запись сохраняется и без правок: её границы заданы заранее */
  isNew?: boolean;
  onSave: () => void;
  onCancel: () => void;
};

/**
 * «Отменить» и «Сохранить» формы записи — у каждой формы свои, у пары реплик при выносе фрагмента общие.
 */
export const TranscriptRecordFormFooter: FC<Props> = ({ isDirty, isSaving, isNew = false, onSave, onCancel }) => {
  const { t } = useTranslation(['common']);

  // На узкой панели подпись о несохранённой правке уходит строкой над «Отменить» и «Сохранить»
  // (они переносятся вместе), а не вылезает за рамку формы влево
  return (
    <SaveButton
      isDirty={isDirty}
      isLoading={isSaving}
      allowSaveWithoutChanges={isNew}
      size="sm"
      className="flex-wrap justify-end"
      onClick={onSave}
      secondaryAction={
        <Button type="button" size="sm" variant="ghost" onClick={onCancel}>
          {t('common:cancel')}
        </Button>
      }
    />
  );
};
